<app-stepper-form
  header="Bulk Change of Name"
  formIcon="ic-change-officer-name-20"
  [showSteps]="false"
  [steps]="steps"
  [currentStep]="currentStep"
  [currentStepIndex]="currentStepIndex"
  [isLoading]="isLoading()"
  [form]="stepperForm"
  (stepIndexChange)="onStepChange($event)"
>
  <div
    class="step-content"
    [formGroup]="stepperForm"
    [class]="{ 'step-content-error': currentStep === StepsEnum.Summary && isGridIncludesError }"
  >
    <app-stepper-form-description
      formKey="484 A2"
      [hidden]="currentStep !== StepsEnum.FormDescription"
    />

    <section
      class="step-section"
      [formGroupName]="StepsEnum.CompanyMemberName"
      [hidden]="currentStep !== StepsEnum.CompanyMemberName"
    >
      <h1 class="h1-heading">{{ steps[currentStep].label }}</h1>

      <div class="form-group">
        <app-date-picker
          label="Date of Change"
          formControlName="changeDate"
          [minDate]="minDate"
          [maxDate]="maxDate"
        />
      </div>

      @if (lateFeeMessage) {
        <app-disclaimer
          color="red"
          icon="ic-info-circle-20"
        >
          {{ lateFeeMessage }}
        </app-disclaimer>
      }

      <div class="form-group">
        <app-input
          label="Name change is applicable to"
          formControlName="name"
          [isDisabled]="true"
        />
      </div>

      <div>
        <h3 class="h3-heading">New Name</h3>

        <div class="form-group" [hidden]="showNameParts">
          <app-input
            label="New Name"
            formControlName="newFullName"
            switchBtnText="Edit Name Details"
            [customErrors]="directorFullNameValidatorMsg"
            (switchBtnClick)="setShowNameParts()"
            (blured)="fillNameParts()"
          />
        </div>

        <div [formGroup]="form.controls.newName" [hidden]="!showNameParts">

          <div class="form-group">
            <app-input
              label="First Name"
              formControlName="firstName"
              switchBtnText="Hide name parts"
              [customErrors]="directorFirstNameValidatorMsg"
              (switchBtnClick)="setShowNameParts(false)"
              (blured)="fillNameParts()"
            />
          </div>

          <div class="form-group">
            <app-input
              label="First Middle Name"
              formControlName="middleName1"
              [customErrors]="directorFirstNameValidatorMsg"
              (blured)="fillNameParts()"
            />
          </div>

          <div class="form-group">
            <app-input
              label="Second Middle Name"
              formControlName="middleName2"
              [customErrors]="directorFirstNameValidatorMsg"
              (blured)="fillNameParts()"
            />
          </div>

          <div class="form-group">
            <app-input
              label="Last Name"
              formControlName="lastName"
              [customErrors]="directorFirstNameValidatorMsg"
              (blured)="fillNameParts()"
            />
          </div>
        </div>
      </div>

      @if (!trustOnly) {
        <div class="document-type mb-3">
          <app-radio
            formControlName="documentationType"
            label="Choose the type of document to generate"
            [options]="documentTypeOptions"
          />
        </div>
      }
    </section>

    <section
      class="step-section gap-32"
      [formGroup]="form"
      [hidden]="currentStep !== StepsEnum.Summary"
    >
      <div class="change">
        <h1 class="h1-heading">Change is applied for</h1>

        @if (colDefs.length) {
          <app-list-grid-client-side
            class="bulk-change-grid"
            [rowData]="rows"
            [colDefs]="colDefs"
            [rowSelection]="rowSelection"
            [rowClassRules]="rowClassRules"
            [suppressRowClickSelection]="true"
            [paginationPageSizeSelector]="false"
            [suppressCellFocus]="true"
          />
        }
      </div>
    </section>
  </div>
</app-stepper-form>
